<template>
  <b-container>
    <h1>{{ $t("system.module.edit") }}</h1>
    <success-fade-alert ref="alert" :msg="alert.success" />
    <fade-alert-danger ref="fadeAlertDanger" :msg="alert.error" />
    <b-row class="mb-3 ml-0">
      <b-col>
        <router-link :to="getUrlBackToList">
          <b-button size="sm">{{ $t("geral.backtolist") }}</b-button>
        </router-link>
      </b-col>
      <b-col class="active">
        <b-button v-if="model.active" size="sm" class="btn-checklist ml-2" @click="deactiveModule">{{
          $t("geral.delete")
        }}</b-button>
        <b-button v-else size="sm" class="btn-checklist ml-2" @click="activeModule">{{
          $t("geral.activate")
        }}</b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12" md="6" lg="6">
        <module-crud-data :model="model" :modelstate="modelstate">
        </module-crud-data>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-button type="submit" :disabled="submitted" @click="save">
          {{ $t("geral.save") }}
        </b-button>
      </b-col>
    </b-row>
    <!-- {{model}} -->
  </b-container>
</template>
<script>
export default {
  components: {
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
    ModuleCrudData: () =>
      import("@/components_rms/System/Module/ModuleCrudData.vue"),
  },
  props: {
    id: String,
  },
  data() {
    return {
      alert: {
        error: "",
        success: "Registro alterado com sucesso",
      },
      submitted: false,
      modelstate: {},
      model: {},
    };
  },
  computed: {
    getUrlBackToList() {
      return `../../module/all`;
    },
  },
  mounted() {
    this.loadData();
  },
  methods: {
    activeModule() {
      this.$apiScheduler
        .post("/module/active/" + this.id)
        .then((response) => {
          this.model.active = true;
          this.alert.success = response.data.title;
          this.$refs.alert.show();
        })
        .catch((error) => {
          console.log(`error: ${error}`);
          console.log(error);
          console.log(`error.response: ${error.response}`);
          console.log(error.response);

          this.alert.error =
            error.response.status + " - " + error.response.statusText;
          this.$refs.danger.show();
        });
    },
    deactiveModule() {
      this.$apiScheduler
        .post("/module/disable/" + this.id)
        .then((response) => {
          this.model.active = false;
          this.alert.success = response.data.title;
          this.$refs.alert.show();
        })
        .catch((error) => {
          console.log(`error: ${error}`);
          console.log(error);
          console.log(`error.response: ${error.response}`);
          console.log(error.response);

          this.alert.error =
            error.response.status + " - " + error.response.statusText;
          this.$refs.danger.show();
        });
    },
    async loadData() {
      console.log(this.id);
      this.$apiScheduler
        .get("/module/get/" + this.id)
        .then((response) => {
          console.log(response);
          let model = response.data;
          this.model = model;
          console.log(this.model);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            console.log(response.data);
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            if (error.response) {
              if (error.response.status == 400) {
                console.log(response.data);
                this.modelstate = error.response.data.errors;
              }
            }
            this.alert.error = error.message;
            this.$refs.danger.show();
          }
        });
    },

    save() {
      this.submitted = true;

      this.$apiScheduler
        .post("/module/edit/" + this.id, this.model)
        .then((response) => {
          console.log(response);
          this.model = response.data;
          this.$forceUpdate();
          this.$refs.alert.show();
          this.modelstate = {};
          this.submitted = false;
        })

        .catch((error) => {
          console.log("error");
          console.log(error);
          this.submitted = false;
          this.modelstate = {};

          if (error.response) {
            console.log(error.response);
            if (error.response.status == 400) {
              this.modelstate = error.response.data.errors;
              this.alert.error = error.message;
              this.$refs.danger.show();
            } else if (error.response.status == 500) {
              this.alert.error = error.response.data;
              this.$refs.danger.show();
            } else {
              this.alert.error = error.message;
              this.$refs.danger.show();
            }
          } else {
            this.alert.error = error.message;
            this.$refs.danger.show();
          }
        });
    },
  },
};
</script>
<style scoped>
.active{
  margin-left: -730px ;
}
</style>